/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Newsletter_ButtonInputs */

const en_newsletter_button = /** @type {(inputs: Newsletter_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscribe`)
};

/**
* | output |
* | --- |
* | "Subscribe" |
*
* @param {Newsletter_ButtonInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const newsletter_button = /** @type {((inputs?: Newsletter_ButtonInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Newsletter_ButtonInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_newsletter_button(inputs)
});